import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { ModalSize } from '../../services/smart-modal.service';
@Injectable()
export class editableGridService {
  constructor(
    //public baseService: BaseService,
    //public alerts: AlertsService,
    //public loader: LoaderService
  ) {

  }
  enableDisabledControl(rowObject: object, rowIndex: number, column: object, columnIndex?: number) { // Enable Disabled item Based on condition
    if (rowObject != undefined && rowIndex != undefined && column != undefined && columnIndex != undefined) {
      if (column.hasOwnProperty('disabled')) {
        if (rowObject.hasOwnProperty(column['disabled']['dependent_field']) && column['disabled']['action'] == 'check_value' && (rowObject[column['disabled']['dependent_field']] != column['disabled']['dependent_value'])) {
          return true;
        } else if (rowObject[column['disabled']['dependent_field']] == "" || rowObject[column['disabled']['dependent_field']] == undefined) {
          return true;
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  }
  conditionBasedVisibility(rowObject: object, rowIndex: number, column: object, columnIndex?: number) { // Enable Disabled item Based on condition
    if (rowObject != undefined && rowIndex != undefined && column != undefined && columnIndex != undefined) {
      if (column.hasOwnProperty('hidden')) {
        if (rowObject.hasOwnProperty(column['hidden']['dependent_field']) && column['hidden']['action'] == 'hidden' && (rowObject[column['hidden']['dependent_field']] == column['hidden']['dependent_value'])) {
          return 'none';
        } else if (rowObject.hasOwnProperty(column['hidden']['dependent_field']) && column['hidden']['action'] == 'hidden' && (rowObject[column['hidden']['dependent_field']] != column['hidden']['dependent_value'])) {
          return null;
        }
        else if (rowObject[column['hidden']['dependent_field']] == "" || rowObject[column['hidden']['dependent_field']] == undefined) {
          return null;
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  }
  checktableHeaderWidth(column) { //{'width': th.component =='inputSearch'? 300+'px':'auto'}
    if (column != undefined && column.hasOwnProperty('component')) {
      switch (column.component) {
        case 'inputSearch': {
          return '270px';
        }
        case 'dropdown': {
          if (column.label.length < 5) {
            return '90px';
          } else {
            return 'auto';
          }
        }
        case 'textbox': {
          if (column.type === 'number') {
            return '80px';
          } else {
            return 'auto';
          }
        }
      }
    }

  }
  checkingModalSize(size?: string) { // check modal size before open popup
    switch (size) {
      case 'sm': {
        return ModalSize.Sm
        break;
      }
      case 'md': {
        return ModalSize.Md
        break;
      }
      case 'lg': {
        return ModalSize.Lg
        break;
      }
      case 'xl': {
        return ModalSize.Xl
        break;
      }
      case 'xxl': {
        return ModalSize.XXl
        break;
      }
      default: {
        return ModalSize.Md
        break;
      }
    }
  }
  preventNumberBoxToTypeSymbols() {  // Listen for input event on numInput.
    //var number = document.getElementsByTagName('number');
    (<HTMLElement>document.getElementsByClassName('numberBox')[0]).onkeydown = function (e) {
      if (!((e.keyCode > 95 && e.keyCode < 106)
        || (e.keyCode > 47 && e.keyCode < 58)
        || e.keyCode == 8)) {
        return false;
      }
    }
  }
  checkedItemGroup(obj1, obj2) {//matches two objects
    // Create arrays of property names
    var aProps = Object.getOwnPropertyNames(obj1);
    var bProps = Object.getOwnPropertyNames(obj2);
    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
      return false;
    }
    for(let i = 0; i < aProps.length; i++) {
      var propName = aProps[i];
      // If values of same property are not equal,
      // objects are not equivalent
      if (obj1[propName] !== obj2[propName]) {
        return false;
      }
    }
    // If we made it this far, objects
    // are considered equivalent
    return true;
  }

}